import React, { useEffect } from "react";
import MuiAppBar from "@mui/material/AppBar";
import { useMsal } from "@azure/msal-react";
import { BASE_PATH } from "../constants";
import BSMLogo from "../assets/bsmLogo.png";
import { Hidden, styled, Toolbar } from "@mui/material";
import ProfileCard from "../pages/loan_app/profile_card";
import { useNavigate } from "react-router-dom";
import { appendQueryParamToURL } from "../helpers";
import { IconButton } from "@mui/material";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { useTranslation } from "react-i18next";
import LangChange from './LangChange';

const resolveLanguageLabel = (lng) => {
  if (lng === 'es') {
    return 'ESP';
  }
  if (!lng || lng.includes("en")) {
    return 'ENG';
  }
  return undefined;
};

const HeaderComponent = React.memo((props) => {
  let navigate = useNavigate();
  const { instance } = useMsal();
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = React.useState(() =>
    resolveLanguageLabel(i18n.language)
  );

 useEffect(() => {
    const previousPath = localStorage.getItem("previousPath");
    const getRequiredPath = localStorage.getItem("requiredPath");
    if (previousPath !== null) {
      if(previousPath !== getRequiredPath) {
        signOutClickHandler();
      }
    }
  }, []);

  const navigateHome = () => {
    localStorage.removeItem("appId");
    localStorage.removeItem("loan-app-dashboard");
    localStorage.removeItem("userName");
    const urlWithParams = appendQueryParamToURL(process.env.REACT_APP_BASE_URL);
    navigate(urlWithParams);
  };
  const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  })(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: "white",
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

  function signOutClickHandler() {
    const logoutRequest = {
      account: instance.getAccountByHomeId(
        window.localStorage.getItem("home_account_id")
      ),
      postLogoutRedirectUri: BASE_PATH,
    };
    const getLarFromLocalStorage = localStorage.getItem("lar");
    const getAppLanguage = localStorage.getItem("i18nextLng");
    const getRequiredPath = localStorage.getItem("requiredPath");
    window.localStorage.clear();
    if(getLarFromLocalStorage !== null) {
      window.localStorage.setItem('lar', getLarFromLocalStorage);
    }
    if(getAppLanguage !== null) {
      window.localStorage.setItem("i18nextLng", getAppLanguage);
    }
    if(getRequiredPath !== null) {
      window.localStorage.setItem("requiredPath", getRequiredPath);
    }
    window.sessionStorage.clear();
    instance.logoutRedirect(logoutRequest);
  }

  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
    setLanguage(resolveLanguageLabel(lng));
  };
  
  return (
    <div>
      <AppBar position="fixed">
        <Toolbar style={{ paddingLeft: "10px" }}>
          <div className="alignRowClassName" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%' }}>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
              {props.pageIndex >= 2 && (
                <IconButton onClick={props.setOpen} sx={{ display: { sm: 'none' } }}>
                  <MenuRoundedIcon />
                </IconButton>
              )}
              <div
                onClick={() => navigateHome()}
                data-testid="logo"
                className="logoDivClassName"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <img src={BSMLogo} alt="BSMLogo" style={{ height: '40px', width: '40px'}} />
                <Hidden smDown>
                  &nbsp;<p className="logoText">BOND STREET MORTGAGE</p>
                </Hidden>
              </div>
            </div>
            <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: "10px" }}>
              <LangChange changeLanguage={(language) => changeLanguage(language)} language={language} />
              <ProfileCard signOutClickHandler={() => signOutClickHandler()} />
            </div>
          </div>
        {/* <button onClick={() => changeLanguage("es")}>Spanish</button>
        <button onClick={() => changeLanguage("en")}>English</button> */}
        </Toolbar>
      </AppBar>
    </div>
  );
});

export default HeaderComponent;
